/* eslint-disable indent */
/* eslint-disable jsx-quotes */
import React from 'react';

const Header = () => (
    <>
    <a href='https://open.spotify.com/genre/new-releases-page' target="_blank" rel="noopener noreferrer"> <h1 className='HeaderText'>New albums & singles</h1> </a>
    <hr />
    </>
);

export default Header;